var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { CustomPicker } from 'react-color';
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common';
import styles from './styles.module.scss';
import './styles.color-picker.scss';
import { hexToHsv } from './utils';
import { TextS } from '../../../../infra/dls/components/typography/typography';
var SliderPointer = function (props) {
    return (_jsx("div", { className: styles['slider-pointer'], children: _jsx("div", { className: styles['slider-pointer-inner'], style: { backgroundColor: "hsl(".concat(props.hsl.h, " 100% 50%") } }) }));
};
var SaturationPointer = function () {
    return _jsx("div", { className: styles['saturation-pointer'] });
};
var CustomColorPicker = function (_a) {
    var selectedColor = _a.selectedColor, onChange = _a.onChange, invalidInputColor = _a.invalidInputColor, onInputChange = _a.onInputChange;
    var saturationProps = { hsl: selectedColor.hsl, hsv: hexToHsv(selectedColor.hex) };
    var hueProps = { hsl: selectedColor.hsl, pointer: SliderPointer };
    var editableInputProps = { className: styles.input };
    var handleChangeInput = function (value) {
        // onChange is handled by CustomPicker and returns ColorResult. If the hex is invalid it will return a default state
        onChange(value);
        // onInputChange will always return the hex value, to handle invalid ones
        onInputChange(value);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(styles.saturation, 'saturation-container'), children: _jsx(Saturation, __assign({ onChange: onChange, pointer: SaturationPointer }, saturationProps)) }), _jsx("div", { className: styles.hue, children: _jsx(Hue, __assign({ onChange: onChange }, hueProps)) }), _jsxs("div", { className: styles['input-container'], children: [_jsx("div", { className: styles['color-preview'], style: { backgroundColor: selectedColor.hex } }), _jsxs("div", { className: styles['input-value'], children: ["#", _jsx(EditableInput, __assign({ value: selectedColor.hex.split('#')[1], onChange: handleChangeInput }, editableInputProps))] })] }), _jsx(TextS, { className: styles['error-label'], color: invalidInputColor ? 'negative' : 'tertiary', children: invalidInputColor ? 'Please enter a valid color code.' : 'Use a hex code like #000000' })] }));
};
var BaseColorPicker = CustomPicker(CustomColorPicker);
export var ColorPicker = function (_a) {
    var onSelectChange = _a.onSelectChange, restProps = __rest(_a, ["onSelectChange"]);
    return _jsx(BaseColorPicker, __assign({ onChange: onSelectChange }, restProps));
};
